import { useEffect, useState, useContext } from 'react';
import { Container, Typography, Stack, Box, CircularProgress } from '@mui/material';
import { ReqCutiForm } from '../../../sections/cabang/cuti';
import { axiosPrivate } from '../../../common/axiosPrivate';
import AuthContext from '../../../context/authContext';

const AddReqCutiPage = ({handleCloseModal, handleUpdateTable}) => {
  const { user } = useContext(AuthContext);
  const [dropDown, setDropDown] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setPageLoading(true);

    const fetchDropdown = async () => {
      try {
        let response;
        if (user?.role === 'area' && user?.kantorList?.length > 0) {
          // GET pakai query param: ?kantorList=KTR001,KTR002&role=area
          response = await axiosPrivate.get('req-cuti/dropdown/list', {
            params: {
              kantorList: user.kantorList.join(','),
              role: user.role
            }
          });
        } else if (user?.kantor) {
          // GET single kantor (endpoint lama)
          response = await axiosPrivate.get(`req-cuti/dropdown/list/${user.kantor}`);
        }
        setDropDown(response?.data || []);
      } catch (error) {
        console.log(error);
      } finally {
        setPageLoading(false);
      }
    };

    fetchDropdown();
  }, [user?.kantor, user?.role, user?.kantorList]);

  return (
    <>
      {pageLoading ? (
        <Box
          sx={{
            flexGrow: 1
          }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          width={"100%"}
        >
          <CircularProgress />
        </Box>) : (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Request Cuti
            </Typography>
          </Stack>
          <ReqCutiForm
            dropDown={dropDown}
            handleCloseModal={handleCloseModal}
            handleUpdateTable={handleUpdateTable}
          />
        </Container>
      )}
    </>
  );
}
  
export default AddReqCutiPage;
